import Api from "../api.js"
import { writable } from "svelte/store";
import axios from "@/lib/axios.js"

export const contentpages = writable();
export const contentpage = writable();

class ContentpageService extends Api {
    constructor() {
        super('/api/contentpages', contentpages, contentpage, 'contentpage');
    }

    async index(config = {}, store = contentpages) {
        return await axios
            .get(`/api/contentpages`, config)
            .then(async (response) => {
                if(config.params?.append === true) {
                    store.set({
                        ...response.data,
                        data: [...get(store).data, ...response.data.data]
                    });
                }
                else {
                    store.set(response.data);
                }
                return response;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }
}

export const service = new ContentpageService('/api/contentpages', contentpages, contentpage);